import React from "react";
import styles from "./VisionMission.module.css";
import socials from "../../data/socials";
import SectionHeading from "../../ReusableComponents/SectionHeading/SectionHeading";
import Reveal from "../../ReusableComponents/Reveal/Reveal";

/**
 * The three pillars, each paired with the prose that belongs to it. Previously
 * the pillars sat in one block and all three paragraphs in another, so nothing
 * connected a claim to the passage explaining it. Wording is unchanged - only
 * redistributed.
 */
const steps = [
  {
    title: "Singapore of the World",
    summary: "Transform Puducherry into the next Singapore of the world.",
    body: [
      "Jose Charles Martin envisions a transformative Puducherry because it's a region destined to become the next Singapore of the world. With its beautiful coastline, strong educational base, and enterprising people, Puducherry holds every element needed to stand tall as a global model of progress and sustainability.",
    ],
  },
  {
    title: "Sustainable City",
    summary: "Build a world-class, sustainable, and inclusive city.",
    body: [
      "He believes that Puducherry deserves to be great not just as a tourist destination, but as a world-class hub of innovation, opportunity, and inclusive growth. His dream is to build a Puducherry that shines with modern infrastructure, clean water, green spaces, advanced technology, and empowered citizens.",
      "By promoting sustainability, clean energy, and responsible urban growth, he aspires to make Puducherry a model coastal city that balances modernization with harmony and care for the environment.",
    ],
  },
  {
    title: "Empowerment",
    summary:
      "Promote education, skills, employment, and environmental responsibility.",
    body: [
      "Jose's mission is deeply rooted in people-first development. He aims to uplift every citizen through quality education, skill development, and dignified employment, ensuring that no one is left behind in the journey of progress.",
      "Through inclusive education, youth empowerment, green initiatives, and innovative entrepreneurship, he seeks to create a society where every individual can live with dignity, security, and pride.",
    ],
  },
];

const CODA =
  "For Jose Charles Martin, Puducherry is not just a place — it is a promise. A promise to become the next Singapore of the world — a symbol of what responsible businessmen, collective effort, and human values can truly achieve. Thereby, he ensures inclusive growth in Puducherry.";


const VisionMission = () => {
  return (
    <section id="vision-mission" className={styles.visionMissionSection}>
      <div className={styles.inner}>
        <SectionHeading
          eyebrow="Where this is going"
          title="Vision & Mission"
        />

        <ol className={styles.steps}>
          {steps.map((step, index) => (
            <Reveal
              as="li"
              className={`${styles.step} ${styles[`tone${index + 1}`]}`}
              key={step.title}
              y={34}
              start="top 88%"
            >
              {/* Oversized numeral behind the block, bleeding past its left
                  edge. aria-hidden because the <ol> already conveys order. */}
              <span className={styles.ghost} aria-hidden="true">
                {index + 1}
              </span>

              <div className={styles.card}>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepSummary}>{step.summary}</p>

                {step.body.map((paragraph) => (
                  <p className={styles.textParagraph} key={paragraph.slice(0, 32)}>
                    {paragraph}
                  </p>
                ))}
              </div>
            </Reveal>
          ))}
        </ol>

        <Reveal className={styles.coda} y={26}>
          <p>{CODA}</p>
        </Reveal>

        <Reveal className={styles.socialMedia} y={24}>
          <h3 className={styles.socialTitle}>Follow JCM's Work</h3>
          <div className={styles.socialLinks}>
            {socials.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className={styles.socialLink}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default VisionMission;
